export const checkPermission = (permissions, check) => {
    let havePermission = Object.values(permissions).filter((item) => item.code == check);
    if (havePermission && havePermission.length > 0) {
        return true;
    }
    return false;
};
